import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import {
  getMotionEditorCreateScenePath,
  getMotionEditorScenePath,
} from '../../MotionEditor/public';
import type { AssetLibraryMediaSelection } from '../assetLibraryMediaSelection';
import type { MascotOpenWithSlot } from '../assetLibraryOpenWithPrefill';
import { stashAssetLibraryOpenWithPrefill } from '../assetLibraryOpenWithPrefill';

export function useAssetLibraryOpenWithActions() {
  const navigate = useNavigate();

  const openMotionEditorFromJob = useCallback(
    ({
      jobId,
      label,
      outputCount,
    }: {
      jobId: string;
      label: string;
      outputCount?: number;
    }) => {
      navigate(getMotionEditorCreateScenePath(jobId, label, outputCount));
    },
    [navigate],
  );

  const openSceneInMotionEditor = useCallback(
    (sceneId: string) => {
      navigate(getMotionEditorScenePath(sceneId));
    },
    [navigate],
  );

  const openComicWithVideo = useCallback(
    (selection: AssetLibraryMediaSelection) => {
      stashAssetLibraryOpenWithPrefill({ target: 'comic', selection });
      navigate('/comic');
    },
    [navigate],
  );

  const openMascotWithMedia = useCallback(
    (slot: MascotOpenWithSlot, selection: AssetLibraryMediaSelection) => {
      stashAssetLibraryOpenWithPrefill({ target: 'mascot', slot, selection });
      navigate('/mascot');
    },
    [navigate],
  );

  return {
    openMotionEditorFromJob,
    openSceneInMotionEditor,
    openComicWithVideo,
    openMascotWithMedia,
  };
}
